import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { class: "card card-feat" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 mb-3 text-center" }, "Erbjudanden", -1)
const _hoisted_5 = { class: "row my-3" }
const _hoisted_6 = { class: "col-sm-6 col-md-3 d-grid" }
const _hoisted_7 = {
  key: 0,
  class: "col-sm-6 col-md-3 d-grid"
}
const _hoisted_8 = { class: "col-sm-6 col-md-3 d-grid" }
const _hoisted_9 = { class: "col-sm-6 col-md-3 d-grid" }
const _hoisted_10 = { class: "col-sm-6 col-md-3 d-grid" }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SfOutgoingLead = _resolveComponent("SfOutgoingLead")!
  const _component_RenovationLoan = _resolveComponent("RenovationLoan")!
  const _component_PropertySharing = _resolveComponent("PropertySharing")!
  const _component_LegalAdvice = _resolveComponent("LegalAdvice")!
  const _component_HouseIdApp = _resolveComponent("HouseIdApp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentPage('SfOutgoingLead'))),
              class: _normalizeClass(["btn btn-light mb-2", { active: _ctx.currentPage == 'SfOutgoingLead' }])
            }, " Mäklare ", 2)
          ]),
          (_ctx.app.applicationId != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCurrentPage('RenovationLoan'))),
                  class: _normalizeClass(["btn btn-light mb-2", { active: _ctx.currentPage == 'RenovationLoan' }])
                }, " Renoveringslån ", 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCurrentPage('PropertySharing'))),
              class: _normalizeClass(["btn btn-light mb-2", { active: _ctx.currentPage == 'PropertySharing' }])
            }, " Andelsboende ", 2)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setCurrentPage('LegalAdvice'))),
              class: _normalizeClass(["btn btn-light mb-2", { active: _ctx.currentPage == 'LegalAdvice' }])
            }, " Juridik ", 2)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setCurrentPage('HouseIdApp'))),
              class: _normalizeClass(["btn btn-light mb-2", { active: _ctx.currentPage == 'HouseIdApp' }])
            }, " Boendeappen ", 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.currentPage == 'SfOutgoingLead')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_SfOutgoingLead, {
                  app: _ctx.app,
                  isLoaded: _ctx.isLoaded
                }, null, 8, ["app", "isLoaded"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentPage == 'RenovationLoan')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_RenovationLoan, { app: _ctx.app }, null, 8, ["app"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentPage == 'PropertySharing')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_PropertySharing, { app: _ctx.app }, null, 8, ["app"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentPage == 'LegalAdvice')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_LegalAdvice, { app: _ctx.app }, null, 8, ["app"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentPage == 'HouseIdApp')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_HouseIdApp, { app: _ctx.app }, null, 8, ["app"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}